module.exports = __webpack_public_path__ + "img/banner-product.173ce3a5.png";